module.exports = __webpack_public_path__ + "img/search.b5d23e64.png";